// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_List from "rescript/lib/es6/belt_List.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Amount$LiveRoom from "../../Amount.bs.js";
import * as Loader$LiveRoom from "../../Loader.bs.js";
import * as I18next$LiveRoom from "../../bindings/I18next.bs.js";
import * as JsxPPXReactSupport from "rescript/lib/es6/jsxPPXReactSupport.js";
import * as PropSpread$LiveRoom from "../../components/PropSpread.bs.js";
import * as CommonStyles$LiveRoom from "../../styles/CommonStyles.bs.js";
import * as Utils_Shared$LiveRoom from "../../Utils/Utils_Shared.bs.js";
import * as AuthTokenHook$LiveRoom from "../../stores/AuthTokenHook.bs.js";
import * as SterlingIcons$LiveRoom from "../../bindings/SterlingIcons.bs.js";
import * as SterlingTokens$LiveRoom from "../../bindings/SterlingTokens.bs.js";
import * as StyleConstants$LiveRoom from "../../styles/StyleConstants.bs.js";
import * as ClientapiQueries$LiveRoom from "../../ClientapiQueries.bs.js";
import * as SterlingTypography$LiveRoom from "../../bindings/SterlingTypography.bs.js";

var cardSlideIn = Curry._1(Css.keyframes, {
      hd: [
        0,
        {
          hd: Css.opacity(0),
          tl: {
            hd: Css.transforms({
                  hd: Css.translate3d(Css.zero, Css.pct(-100), Css.zero),
                  tl: {
                    hd: Css.rotateX(Css.deg(90)),
                    tl: /* [] */0
                  }
                }),
            tl: /* [] */0
          }
        }
      ],
      tl: {
        hd: [
          40,
          {
            hd: Css.transforms({
                  hd: Css.translate3d(Css.zero, Css.zero, Css.zero),
                  tl: {
                    hd: Css.rotateX(Css.deg(0)),
                    tl: /* [] */0
                  }
                }),
            tl: /* [] */0
          }
        ],
        tl: {
          hd: [
            100,
            {
              hd: Css.opacity(100),
              tl: /* [] */0
            }
          ],
          tl: /* [] */0
        }
      }
    });

function eventStyle(shouldAnimate) {
  return Curry._1(Css.style, {
              hd: Css.display("flex"),
              tl: {
                hd: Css.justifyContent("center"),
                tl: {
                  hd: Css.alignItems("center"),
                  tl: {
                    hd: Css.minHeight(Css.px(40)),
                    tl: {
                      hd: Css.marginTop(Css.px(8)),
                      tl: /* [] */0
                    }
                  }
                }
              }
            }) + (
          shouldAnimate ? " " + Curry._1(Css.style, {
                  hd: Css.animationDuration(StyleConstants$LiveRoom.animationSlow),
                  tl: {
                    hd: Css.animationTimingFunction(Css.easeInOut),
                    tl: {
                      hd: Css.animationName(cardSlideIn),
                      tl: {
                        hd: Css.animationDirection(Css.normal),
                        tl: /* [] */0
                      }
                    }
                  }
                }) : ""
        );
}

function saleroomNoticeFilter(events) {
  return Belt_List.reduce(events, [
                /* [] */0,
                undefined
              ], (function (param, feedEvent) {
                  var maybeSrn = param[1];
                  var events = param[0];
                  var $$event = feedEvent[0];
                  var match = $$event.type;
                  if (typeof match === "object" && match.NAME === "SaleroomNotice") {
                    if (match.VAL.notice === "") {
                      return [
                              events,
                              feedEvent
                            ];
                    } else if (maybeSrn !== undefined) {
                      return [
                              events,
                              maybeSrn
                            ];
                    } else {
                      return [
                              Belt_List.concat(events, {
                                    hd: feedEvent,
                                    tl: /* [] */0
                                  }),
                              feedEvent
                            ];
                    }
                  }
                  return [
                          Belt_List.concat(events, {
                                hd: feedEvent,
                                tl: /* [] */0
                              }),
                          maybeSrn
                        ];
                }))[0];
}

function EventFeed$BidFeedNote(props) {
  var className = props.className;
  var className$1 = className !== undefined ? className : "";
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: eventStyle(props.shouldAnimate),
                    tl: {
                      hd: Curry._1(Css.style, {
                            hd: Css.backgroundColor(props.color),
                            tl: {
                              hd: Css.borderRadius(Css.px(4)),
                              tl: {
                                hd: Css.minHeight(Css.px(24)),
                                tl: {
                                  hd: Css.width(Css.fitContent),
                                  tl: {
                                    hd: Css.padding2(Css.px(0), Css.px(16)),
                                    tl: {
                                      hd: Css.alignSelf(Css.center),
                                      tl: /* [] */0
                                    }
                                  }
                                }
                              }
                            }
                          }),
                      tl: {
                        hd: className$1,
                        tl: /* [] */0
                      }
                    }
                  })
            }, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "bidFeedNote"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                        children: props.text
                      })
                }));
}

var BidFeedNote = {
  make: EventFeed$BidFeedNote
};

function EventFeed$SaleroomNotice(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: eventStyle(props.shouldAnimate),
                    tl: {
                      hd: Curry._1(Css.style, {
                            hd: Css.minHeight("unset"),
                            tl: {
                              hd: Css.flexDirection("column"),
                              tl: {
                                hd: Css.backgroundColor(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey10_nohashtag)),
                                tl: {
                                  hd: Css.borderRadius(Css.px(4)),
                                  tl: {
                                    hd: Css.padding2(Css.px(16), Css.px(24)),
                                    tl: /* [] */0
                                  }
                                }
                              }
                            }
                          }),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                  children: Curry._1(match.t, "Common_saleroomNotice")
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "salesRoomNotice"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                        children: props.text
                      })
                }));
}

var SaleroomNotice = {
  make: EventFeed$SaleroomNotice
};

function EventFeed$Comment(props) {
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: eventStyle(props.shouldAnimate),
                    tl: {
                      hd: Curry._1(Css.style, {
                            hd: Css.minHeight("unset"),
                            tl: {
                              hd: Css.padding2(Css.px(16), Css.px(24)),
                              tl: /* [] */0
                            }
                          }),
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "commentFeed"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.textAlign("center"),
                              tl: /* [] */0
                            }),
                        children: props.comment
                      })
                }));
}

var $$Comment = {
  make: EventFeed$Comment
};

function EventFeed$UserBid(props) {
  var match = I18next$LiveRoom.useTranslation(undefined);
  return React.createElement("div", {
              className: eventStyle(props.shouldAnimate)
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.flex({
                              NAME: "num",
                              VAL: 1
                            }),
                        tl: /* [] */0
                      })
                }), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "userBidValue"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                              tl: {
                                hd: Css.flex({
                                      NAME: "num",
                                      VAL: 1
                                    }),
                                tl: {
                                  hd: Css.textAlign("center"),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        children: "" + Utils_Shared$LiveRoom.Numbers.withCommas(props.amount) + " " + Amount$LiveRoom.currencyToString(props.currency) + ""
                      })
                }), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                        tl: {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: {
                              hd: Css.flex({
                                    NAME: "num",
                                    VAL: 1
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "userBidLabel"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                            className: Curry._1(Css.style, {
                                  hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue60_nohashtag)),
                                  tl: {
                                    hd: Css.textAlign("right"),
                                    tl: {
                                      hd: Css.marginRight(Css.px(6)),
                                      tl: {
                                        hd: Css.flex({
                                              NAME: "num",
                                              VAL: 1
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }),
                            children: Curry._1(match.t, "FeedComponent_yourBid")
                          })
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      aria: {
                        hd: {
                          TAG: /* Hidden */2,
                          _0: true
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingIcons$LiveRoom.Collection.User24.make, {})
                    })));
}

var UserBid = {
  make: EventFeed$UserBid
};

function EventFeed$OpposingBid(props) {
  return React.createElement("div", {
              className: eventStyle(props.shouldAnimate)
            }, React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                        tl: {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.alignItems("center"),
                            tl: {
                              hd: Css.flex({
                                    NAME: "num",
                                    VAL: 1
                                  }),
                              tl: /* [] */0
                            }
                          }
                        }
                      })
                }, React.createElement(PropSpread$LiveRoom.make, {
                      aria: {
                        hd: {
                          TAG: /* Hidden */2,
                          _0: true
                        },
                        tl: /* [] */0
                      },
                      children: props.icon
                    }), React.createElement(PropSpread$LiveRoom.make, {
                      data: {
                        hd: {
                          TAG: /* TestId */1,
                          _0: "sourceBidLabel"
                        },
                        tl: /* [] */0
                      },
                      children: React.createElement(SterlingTypography$LiveRoom.Label14Medium.make, {
                            className: Curry._1(Css.style, {
                                  hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                                  tl: {
                                    hd: Css.textAlign("left"),
                                    tl: {
                                      hd: Css.marginLeft(Css.px(6)),
                                      tl: {
                                        hd: Css.flex({
                                              NAME: "num",
                                              VAL: 1
                                            }),
                                        tl: /* [] */0
                                      }
                                    }
                                  }
                                }),
                            children: props.text
                          })
                    })), React.createElement(PropSpread$LiveRoom.make, {
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "valueBidText"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement(SterlingTypography$LiveRoom.Paragraph14Regular.make, {
                        className: Curry._1(Css.style, {
                              hd: Css.color(Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey100_nohashtag)),
                              tl: {
                                hd: Css.flex({
                                      NAME: "num",
                                      VAL: 1
                                    }),
                                tl: {
                                  hd: Css.textAlign("center"),
                                  tl: /* [] */0
                                }
                              }
                            }),
                        children: "" + Utils_Shared$LiveRoom.Numbers.withCommas(props.amount) + " " + Amount$LiveRoom.currencyToString(props.currency) + ""
                      })
                }), React.createElement("div", {
                  className: Curry._1(Css.style, {
                        hd: Css.flex({
                              NAME: "num",
                              VAL: 1
                            }),
                        tl: /* [] */0
                      })
                }));
}

var OpposingBid = {
  make: EventFeed$OpposingBid
};

function EventFeed$EventItem(props) {
  var currency = props.currency;
  var lotNumber = props.lotNumber;
  var shouldAnimate = props.shouldAnimate;
  var $$event = props.event;
  var match = I18next$LiveRoom.useTranslation(undefined);
  var t2 = match.t2;
  var t = match.t;
  if (typeof $$event !== "object") {
    return null;
  }
  var variant = $$event.NAME;
  if (variant === "Comment") {
    return React.createElement(EventFeed$Comment, {
                comment: $$event.VAL.comment,
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "UserBidFeed") {
    var match$1 = $$event.VAL;
    var bidAmount = match$1.bidAmount;
    if (match$1.isMyBid) {
      return React.createElement(EventFeed$UserBid, {
                  amount: bidAmount,
                  currency: currency,
                  shouldAnimate: shouldAnimate
                });
    }
    var isAdvance = match$1.isAdvance;
    var text = isAdvance ? Curry._1(t, "FeedComponent_advanceBid") : Curry._1(t, "FeedComponent_online");
    return React.createElement(EventFeed$OpposingBid, {
                amount: bidAmount,
                currency: currency,
                text: text,
                icon: isAdvance ? React.createElement(SterlingIcons$LiveRoom.Collection.Gavel24.make, {}) : React.createElement(SterlingIcons$LiveRoom.Collection.Browser24.make, {}),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "ConsignorBid") {
    var match$2 = $$event.VAL;
    var text$1 = match$2.previousBidIsSameAmount ? (
        match$2.previousBidWasMine ? Curry._1(t, "FeedComponent_bidAheadOfYou") : Curry._1(t, "FeedComponent_bidAheadOfLast")
      ) : (
        match$2.isAdvance ? Curry._1(t, "FeedComponent_advanceBid") : Curry._1(t, "FeedComponent_bid")
      );
    return React.createElement(EventFeed$OpposingBid, {
                amount: match$2.bidAmount,
                currency: currency,
                text: text$1,
                icon: React.createElement(SterlingIcons$LiveRoom.Collection.Gavel24.make, {}),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "StartingBidUpdated") {
    if (props.lotIsLive) {
      return React.createElement(EventFeed$BidFeedNote, {
                  text: Curry._2(t2, "FeedComponent_nextBid", {
                        amount: Utils_Shared$LiveRoom.Numbers.withCommas($$event.VAL.newStartingBid),
                        currency: Amount$LiveRoom.currencyToString(currency)
                      }),
                  color: Css.hex(""),
                  shouldAnimate: shouldAnimate
                });
    } else {
      return null;
    }
  }
  if (variant === "FairWarning") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._1(t, "FeedComponent_fairWarning"),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.alertYellow20_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "LotWithdrawn") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._1(t, "LotListContainer_lotWithdrawn"),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.primaryGrey20_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "ConfirmSaleResult") {
    if (props.isMostRecentEvent) {
      return React.createElement(EventFeed$BidFeedNote, {
                  text: Curry._1(t, "FeedComponent_lotIsClosing"),
                  color: Css.hex(""),
                  shouldAnimate: shouldAnimate
                });
    } else {
      return null;
    }
  }
  if (variant === "LotOpened" || variant === "LotContinued") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._2(t2, "FeedComponent_lotIsNowOpenForBidding", {
                      lotNr: lotNumber
                    }),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.primaryBlue10_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "LotClosed") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._1(t, "Common_lotClosed"),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "BidAskAdjusted") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._2(t2, "FeedComponent_nextBid", {
                      amount: Utils_Shared$LiveRoom.Numbers.withCommas($$event.VAL.newBidAsk),
                      currency: Amount$LiveRoom.currencyToString(currency)
                    }),
                color: Css.hex(""),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "LotReopened") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._1(t, "FeedComponent_lotIsReopenedForBidding"),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.alertGreen20_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "AdminBid") {
    var match$3 = $$event.VAL;
    var bidType = match$3.bidType;
    var bidAmount$1 = match$3.bidAmount;
    if (bidType !== undefined) {
      if (bidType === "PHONE") {
        return React.createElement(EventFeed$OpposingBid, {
                    amount: bidAmount$1,
                    currency: currency,
                    text: Curry._1(t, "FeedComponent_phone"),
                    icon: React.createElement(SterlingIcons$LiveRoom.Collection.Telephone24.make, {}),
                    shouldAnimate: shouldAnimate
                  });
      } else if (bidType === "FLOOR") {
        return React.createElement(EventFeed$OpposingBid, {
                    amount: bidAmount$1,
                    currency: currency,
                    text: Curry._1(t, "FeedComponent_room"),
                    icon: React.createElement(SterlingIcons$LiveRoom.Collection.Paddle24.make, {}),
                    shouldAnimate: shouldAnimate
                  });
      } else {
        return null;
      }
    } else {
      return null;
    }
  }
  if (variant === "SaleroomNotice") {
    return React.createElement(EventFeed$SaleroomNotice, {
                text: $$event.VAL.notice,
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "AbsenteeBidAmountReached") {
    var match$4 = $$event.VAL;
    if (match$4.bidAheadOfYou) {
      return React.createElement(EventFeed$BidFeedNote, {
                  text: Curry._2(t2, "FeedComponent_anEqualBid", {
                        amount: Utils_Shared$LiveRoom.Numbers.withCommas(match$4.bidAmount),
                        currency: currency
                      }),
                  color: Css.hex(SterlingTokens$LiveRoom.Colors.alertOrange20_nohashtag),
                  shouldAnimate: shouldAnimate,
                  className: Curry._1(Css.style, {
                        hd: Css.minHeight("unset"),
                        tl: {
                          hd: Css.textAlign("center"),
                          tl: /* [] */0
                        }
                      })
                });
    } else {
      return null;
    }
  }
  if (variant === "UndoBid") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._1(t, "FeedComponent_bidWithdrawn"),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.alertRed20_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "LotUnWithdrawn") {
    return React.createElement(EventFeed$BidFeedNote, {
                text: Curry._2(t2, "FeedComponent_lotReinstated", {
                      lotNr: lotNumber
                    }),
                color: Css.hex(SterlingTokens$LiveRoom.Colors.alertGreen20_nohashtag),
                shouldAnimate: shouldAnimate
              });
  }
  if (variant === "LotSoldFeedEvent") {
    if (props.isWinner) {
      return React.createElement(EventFeed$BidFeedNote, {
                  text: Curry._2(t2, "LotWon", {
                        lotNumber: lotNumber
                      }),
                  color: Css.hex(SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag),
                  shouldAnimate: shouldAnimate
                });
    } else {
      return React.createElement(EventFeed$BidFeedNote, {
                  text: Curry._1(t, "Common_lotClosed"),
                  color: Css.hex(SterlingTokens$LiveRoom.Colors.primaryGold60_nohashtag),
                  shouldAnimate: shouldAnimate
                });
    }
  }
  if (variant !== "ReactiveBid") {
    return null;
  }
  var match$5 = $$event.VAL;
  var currentBidIsMine = match$5.currentBidIsMine;
  var previousBidWasMine = match$5.previousBidWasMine;
  var match$6;
  if (match$5.previousBidIsSameAmount) {
    var exit = 0;
    if (currentBidIsMine && !previousBidWasMine) {
      match$6 = [
        Curry._1(t, "FeedComponent_yourBidAheadOfLast"),
        React.createElement(SterlingIcons$LiveRoom.Collection.User24.make, {})
      ];
    } else {
      exit = 1;
    }
    if (exit === 1) {
      match$6 = previousBidWasMine ? [
          Curry._1(t, "FeedComponent_bidAheadOfYou"),
          React.createElement(SterlingIcons$LiveRoom.Collection.Gavel24.make, {})
        ] : [
          Curry._1(t, "FeedComponent_bidAheadOfLast"),
          React.createElement(SterlingIcons$LiveRoom.Collection.Gavel24.make, {})
        ];
    }
    
  } else {
    match$6 = currentBidIsMine ? [
        Curry._1(t, "FeedComponent_yourBid"),
        React.createElement(SterlingIcons$LiveRoom.Collection.User24.make, {})
      ] : (
        match$5.isAdvance ? [
            Curry._1(t, "FeedComponent_advanceBid"),
            React.createElement(SterlingIcons$LiveRoom.Collection.Gavel24.make, {})
          ] : [
            Curry._1(t, "FeedComponent_bid"),
            React.createElement(SterlingIcons$LiveRoom.Collection.Gavel24.make, {})
          ]
      );
  }
  return React.createElement(EventFeed$OpposingBid, {
              amount: match$5.bidAmount,
              currency: currency,
              text: match$6[0],
              icon: match$6[1],
              shouldAnimate: shouldAnimate
            });
}

var EventItem = {
  make: EventFeed$EventItem
};

function EventFeed(props) {
  var className = props.className;
  var direction = props.direction;
  var isWinner = props.isWinner;
  var eventFeedHeight = props.eventFeedHeight;
  var currency = props.currency;
  var lotIsLive = props.lotIsLive;
  var lotNr = props.lotNr;
  var lotId = props.lotId;
  var eventFeedHeight$1 = eventFeedHeight !== undefined ? eventFeedHeight : Css.pct(100);
  var direction$1 = direction !== undefined ? direction : "BottomUp";
  var className$1 = className !== undefined ? className : "";
  var scrollContainerRef = React.useRef(null);
  var match = React.useReducer((function (state, action) {
          if (typeof action !== "number") {
            if (action.TAG === /* AddEventToFeed */0) {
              return {
                      feed: Belt_List.add(state.feed, [
                            action._0,
                            false
                          ]),
                      isLoading: state.isLoading,
                      isSwitching: state.isSwitching,
                      initialFeed: state.initialFeed
                    };
            } else {
              return {
                      feed: state.feed,
                      isLoading: state.isLoading,
                      isSwitching: state.isSwitching,
                      initialFeed: Belt_List.add(state.initialFeed, action._0)
                    };
            }
          }
          switch (action) {
            case /* SwitchFeed */0 :
                return {
                        feed: state.feed,
                        isLoading: state.isLoading,
                        isSwitching: true,
                        initialFeed: /* [] */0
                      };
            case /* PopulateFeed */1 :
                return {
                        feed: Belt_List.map(state.initialFeed, (function (item) {
                                return [
                                        item,
                                        true
                                      ];
                              })),
                        isLoading: false,
                        isSwitching: false,
                        initialFeed: state.initialFeed
                      };
            case /* ToggleLoader */2 :
                return {
                        feed: state.feed,
                        isLoading: !state.isLoading,
                        isSwitching: state.isSwitching,
                        initialFeed: state.initialFeed
                      };
            
          }
        }), {
        feed: /* [] */0,
        isLoading: false,
        isSwitching: true,
        initialFeed: /* [] */0
      });
  var dispatch = match[1];
  var state = match[0];
  React.useEffect((function () {
          Curry._1(dispatch, /* SwitchFeed */0);
        }), [lotId]);
  var lotNumber = typeof lotNr === "object" && lotNr.NAME === "VisibleLotNumber" ? lotNr.VAL.lotNumber : "";
  var timeout = React.useRef(undefined);
  var authToken = AuthTokenHook$LiveRoom.useToken("EventFeed-LiveRoom");
  Curry._7(ClientapiQueries$LiveRoom.LotFeed.LotFeedSubscription.use, undefined, undefined, (function (param) {
          var match = param.subscriptionData.data;
          if (match === undefined) {
            return ;
          }
          var feedItem = match.lotFeed;
          if (feedItem !== undefined) {
            if (state.isSwitching) {
              if (!Belt_List.some(state.initialFeed, (function ($$event) {
                        return $$event.id === feedItem.id;
                      }))) {
                if (!state.isLoading) {
                  Curry._1(dispatch, /* ToggleLoader */2);
                }
                Curry._1(dispatch, {
                      TAG: /* AddEventToInitialFeed */1,
                      _0: feedItem
                    });
                Belt_Option.map(timeout.current, (function (timeoutId) {
                        clearTimeout(timeoutId);
                      }));
                timeout.current = Caml_option.some(setTimeout((function (param) {
                            Curry._1(dispatch, /* PopulateFeed */1);
                          }), 250));
                return ;
              } else {
                return ;
              }
            } else {
              var ref = Belt_Option.getExn(Caml_option.nullable_to_opt(scrollContainerRef.current));
              var scrollTop = ref.scrollTop;
              if (!Belt_List.some(state.feed, (function (param) {
                        return param[0].id === feedItem.id;
                      }))) {
                Curry._1(dispatch, {
                      TAG: /* AddEventToFeed */0,
                      _0: feedItem
                    });
              }
              if (scrollTop < -50) {
                ref.scrollTop = scrollTop - 40;
                return ;
              } else if (scrollTop < 0 || scrollTop > 0) {
                ref.scrollTop = 0;
                return ;
              } else {
                return ;
              }
            }
          }
          
        }), undefined, undefined, typeof authToken === "object" ? authToken.NAME !== "Authenticated" : authToken !== "Unauthenticated", Curry._2(ClientapiQueries$LiveRoom.LotFeed.LotFeedSubscription.makeVariables, lotId, undefined));
  var sortFeed = function (feed) {
    if (direction$1 === "BottomUp") {
      return feed;
    } else {
      return Belt_Array.reverse(feed);
    }
  };
  return React.createElement("div", {
              className: Curry._1(Css.merge, {
                    hd: Curry._1(Css.style, {
                          hd: Css.display("flex"),
                          tl: {
                            hd: Css.alignItems("flexEnd"),
                            tl: {
                              hd: Css.flexDirection("column"),
                              tl: {
                                hd: Css.height(Css.pct(100)),
                                tl: /* [] */0
                              }
                            }
                          }
                        }),
                    tl: {
                      hd: className$1,
                      tl: /* [] */0
                    }
                  })
            }, React.createElement(PropSpread$LiveRoom.make, {
                  aria: {
                    hd: {
                      TAG: /* Live */5,
                      _0: "polite"
                    },
                    tl: /* [] */0
                  },
                  data: {
                    hd: {
                      TAG: /* TestId */1,
                      _0: "feedActivity"
                    },
                    tl: /* [] */0
                  },
                  children: React.createElement("div", {
                        ref: Caml_option.some(scrollContainerRef),
                        className: Curry._1(Css.style, {
                              hd: Css.padding3(Css.zero, Css.zero, Css.px(16)),
                              tl: {
                                hd: Css.display("flex"),
                                tl: {
                                  hd: Css.flexDirection("columnReverse"),
                                  tl: {
                                    hd: Css.width(Css.pct(100)),
                                    tl: {
                                      hd: Css.height(eventFeedHeight$1),
                                      tl: {
                                        hd: Css.overflowY("auto"),
                                        tl: {
                                          hd: Css.unsafe("-webkit-overflow-scrolling", "touch"),
                                          tl: {
                                            hd: Css.opacity(state.isSwitching ? 0.0 : 1.0),
                                            tl: {
                                              hd: Css.transition(StyleConstants$LiveRoom.animationSlow, undefined, undefined, "opacity"),
                                              tl: {
                                                hd: CommonStyles$LiveRoom.mediaV2(/* Mobile */1, {
                                                      hd: Css.padding("zero"),
                                                      tl: {
                                                        hd: Css.transition(undefined, undefined, undefined, "none"),
                                                        tl: /* [] */0
                                                      }
                                                    }),
                                                tl: /* [] */0
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            })
                      }, sortFeed(Belt_List.toArray(Belt_List.mapWithIndex(saleroomNoticeFilter(state.feed), (function (index, param) {
                                      var $$event = param[0];
                                      return JsxPPXReactSupport.createElementWithKey($$event.id, EventFeed$EventItem, {
                                                  event: $$event.type,
                                                  shouldAnimate: index === 0 && !param[1],
                                                  lotNumber: lotNumber,
                                                  currency: currency,
                                                  isMostRecentEvent: index === 0,
                                                  isWinner: isWinner,
                                                  lotIsLive: lotIsLive
                                                });
                                    })))))
                }), state.isLoading ? React.createElement("div", {
                    className: Curry._1(Css.style, {
                          hd: Css.width(Css.pct(100)),
                          tl: {
                            hd: Css.marginBottom(Css.px(16)),
                            tl: /* [] */0
                          }
                        })
                  }, React.createElement(Loader$LiveRoom.Ellipsis.make, {})) : null);
}

var feedTransitionDuration = StyleConstants$LiveRoom.animationSlow;

var make = EventFeed;

export {
  cardSlideIn ,
  eventStyle ,
  saleroomNoticeFilter ,
  BidFeedNote ,
  SaleroomNotice ,
  $$Comment ,
  UserBid ,
  OpposingBid ,
  EventItem ,
  feedTransitionDuration ,
  make ,
}
/* cardSlideIn Not a pure module */
